const doc = [({"en":({"js":({"merfoto":({"photo_session_group_contact_tokens":({"create_from_token_form":({"enter_your_token_here":"Enter your token here..."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;